import * as React from "react";
const SvgRefresh = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M3.99999 8.85645C3.99999 7.75645 4.44666 6.75645 5.17332 6.02978L4.22666 5.08311C3.26666 6.04978 2.66666 7.38311 2.66666 8.85645C2.66666 11.5764 4.69999 13.8164 7.33332 14.1431V12.7964C5.44666 12.4764 3.99999 10.8364 3.99999 8.85645ZM13.3333 8.85645C13.3333 5.90978 10.9467 3.52311 7.99999 3.52311C7.95999 3.52311 7.91999 3.52978 7.87999 3.52978L8.60666 2.80311L7.66666 1.85645L5.33332 4.18978L7.66666 6.52311L8.60666 5.58311L7.88666 4.86311C7.92666 4.86311 7.96666 4.85645 7.99999 4.85645C10.2067 4.85645 12 6.64978 12 8.85645C12 10.8364 10.5533 12.4764 8.66666 12.7964V14.1431C11.3 13.8164 13.3333 11.5764 13.3333 8.85645Z",
	fill: "#333333"
}));
export default SvgRefresh;
